import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import Modal from '../../controls/Modal';
import LabeledInput from '../../controls/LabeledInput';
import AppMediaList from '../../controls/media/AppMediaList';
import DozorCodeCreator from '../../../../../component/dozor/DozorCodeCreator';

// Модалка редактирования точки Дозора: параметры, коды (верные/неверные), медиа.
export default function PointModal({ pointId, dozorState, onClose }) {
    const { enqueueSnackbar } = useSnackbar();
    const [data, setData] = useState(null);
    const [media, setMedia] = useState([]);
    const [pending, setPending] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        dozorState.loadPointDetails(pointId).then(d => {
            if (!mounted) return;
            setData({ title: d.title || '', orderId: d.orderId || 1, incorrectCodeCost: d.incorrectCodeCost || 5, description: d.description || '', dozorCodes: d.dozorCodes || [], time: d.time || '00:10:00', textHint: d.textHint || '' });
            setMedia(d.mediaList || []);
            setLoading(false);
        }).catch(() => { if (mounted) { enqueueSnackbar('Ошибка при загрузке данных точки', { variant: 'error' }); setLoading(false); } });
        return () => { mounted = false; };
    }, [pointId, dozorState, enqueueSnackbar]);

    const set = (field, value) => setData(prev => ({ ...prev, [field]: value }));

    const handleCodes = (type, codes) => {
        const val = (c) => c.codeValue || c.value;
        if (type === 'APPEND') {
            const next = [...data.dozorCodes, ...codes].filter((o, i, self) => i === self.findIndex(x => val(x) === val(o)));
            set('dozorCodes', next);
        }
        if (type === 'DELETE') {
            const removed = codes.map(val);
            set('dozorCodes', data.dozorCodes.filter(it => !removed.includes(val(it))));
        }
    };

    const save = async () => {
        try {
            const existing = media.filter(it => !it.__pending);
            await dozorState.savePoint(pointId, { ...data, mediaList: existing }, pending);
            setPending([]);
            onClose();
        } catch (e) { /* ошибку покажет хук */ }
    };
    const del = async () => { onClose(); await dozorState.deletePoint(pointId); };

    if (loading || !data) {
        return <Modal open title="Точка" size="lg" onClose={onClose}><div className="vp-empty">Загрузка…</div></Modal>;
    }

    const correctCodes = data.dozorCodes.filter(c => c.correct === true);
    const incorrectCodes = data.dozorCodes.filter(c => c.correct === false);

    const footer = (
        <>
            <button type="button" className="btn btn-danger" style={{ marginRight: 'auto' }} onClick={del}>Удалить</button>
            <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
            <button type="button" className="btn btn-primary" onClick={save}>Сохранить</button>
        </>
    );

    return (
        <Modal open kicker="Точка" title="Редактирование точки" size="lg" onClose={onClose} footer={footer}>
            <div className="fr-grid2">
                <LabeledInput label="Номер" value={String(data.orderId)} onChange={(e) => set('orderId', e.target.value)} />
                <LabeledInput label="Название точки" value={data.title} onChange={(e) => set('title', e.target.value)} />
            </div>
            <div className="fr-grid2">
                <LabeledInput label="Время (ЧЧ:ММ:СС)" value={data.time} onChange={(e) => set('time', e.target.value)} />
                <LabeledInput label="Цена ошибки" type="number" value={String(data.incorrectCodeCost)} onChange={(e) => set('incorrectCodeCost', e.target.value)} />
            </div>
            <div>
                <label className="ctl-label">Описание точки (для организаторов)</label>
                <textarea className="textarea" value={data.description} onChange={(e) => set('description', e.target.value)} />
            </div>
            <div className="fr-grid2">
                <DozorCodeCreator isCorrect codes={correctCodes} currentPoint={{ id: pointId }} onChangeFunction={handleCodes} />
                <DozorCodeCreator isCorrect={false} codes={incorrectCodes} currentPoint={{ id: pointId }} onChangeFunction={handleCodes} />
            </div>
            <div>
                <label className="ctl-label">Текстовая подсказка</label>
                <textarea className="textarea" value={data.textHint} onChange={(e) => set('textHint', e.target.value)} />
            </div>
            <div>
                <div className="section-label">Медиа</div>
                <AppMediaList value={media} pendingFiles={pending} onChange={(v, p) => { setMedia(v); setPending(p); }} type="ALL" />
            </div>
        </Modal>
    );
}

PointModal.propTypes = {
    pointId: PropTypes.number.isRequired,
    dozorState: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};
